import { useRouter } from "next/router";
import { useEffect } from "react";
import { logger } from "../utils/logger";
import { useUser } from "./use-user";

// export const signupStatusKey = "signup-status";
// export type SignupStatus = {
//   redirect?: "organization" | "user";
// };

export function useAuthB2BRedirect() {
  const { systemUser, sessionUser, userIsLoading } = useUser(false);
  const router = useRouter();
  const isLoading = userIsLoading || router.isFallback;

  useEffect(() => {
    if (isLoading || !sessionUser) {
      return;
    }

    const facilitatedOrganization = systemUser?.facilitatedOrganizations?.[0];
    const hasActiveSub = !!facilitatedOrganization?.billing?.active;

    if (hasActiveSub) {
      router.push("/hub");
    } else if (!hasActiveSub) {
      router.push("/authentication/signin-organization/no-access");
    } else {
      logger.info("No redirect");
    }
  }, [isLoading, router, systemUser, sessionUser]);

  return {
    isLoading,
  };
}
